import React from "react";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import { useSelector } from "react-redux";
import { sharedLib } from "@shared/services/shared.service";
import EmptyView from "common/Empty/EmptyView";
import { EmptyStatesType } from "common/Icons/types.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const NoGroupsFound = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.GROUPS);
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const user = useSelector(sharedLib.selectors.authentication.selectUser);

  const getExternalAccount = () => {
    if (user?.is_telegram_connected) return t("common.telegram");
    else if (user?.is_discord_connected) return t("common.discord");
    return t("common.external_account");
  };

  return (
    <EmptyView
      title={t("no_groups_found.title")}
      iconKey={EmptyStatesType.FileSearch}
      iconWidth={120}
      description={t("no_groups_found.description", {
        account: getExternalAccount(),
      })}
      style={{ maxWidth: isMobile ? 250 : "100%" }}
    />
  );
};

export default NoGroupsFound;
